import React from 'react';
import {observer} from 'mobx-react';
import {Input, Select2} from 'components';
import _ from 'lodash';

export const PayRate = observer(({model, uiState}) => {
  const {massUpdate} = uiState;

  let newPayRate = null;
  if (massUpdate.newValues.has(model.id) && massUpdate.newValues.get(model.id).has('payRate')) {
    newPayRate = massUpdate.newValues.get(model.id).get('payRate');
  } else if (massUpdate.bulkEditValues.has('payRate')) {
    newPayRate = (parseFloat(model.previousPayRate) * (1 + (massUpdate.bulkEditValues.get('payRate') / 100))).toFixed(2);
  }

  return (
    <Input
      value={massUpdate.readOnly ? model.payRate : newPayRate}
      onChange={e => uiState.updateValue(e.target.value, model, 'payRate')}
      disabled={massUpdate.readOnly}
    />
  );
});

export const PreviousManager = observer(({model, uiState}) => {
  return (
    <div>
      {uiState.managerNameForId(model.previousManagerId)}
    </div>
  );
});

export const Manager = observer(({model, uiState}) => {
  const {massUpdate, employees} = uiState;

  let manager = null;
  if (massUpdate.newValues.has(model.id) && massUpdate.newValues.get(model.id).has('manager')) {
    manager = massUpdate.newValues.get(model.id).get('manager');
  } else if (massUpdate.bulkEditValues.has('manager')) {
    manager = massUpdate.bulkEditValues.get('manager');
    if (manager === model.employee.id) {
      manager = model.employee.managerId;
    }
  }

  return (
    <Select2 searchable allowClear
             value={massUpdate.readOnly ? model.managerId : manager}
             disabled={massUpdate.readOnly}
             onChange={e => uiState.updateValue(e.target.value, model, 'manager')}>
      {employees.map(employee => {
        if (employee.id === model.employee.id) return null;
        return <option key={employee.id} value={employee.id}>{employee.name}</option>;
      })}
    </Select2>
  );
});
